import { FC } from 'react';
import { EpisodeIframeProps } from './types';

export const EpisodeIframe: FC<EpisodeIframeProps> = ({
  episode,
  width = '100%',
}) => {
  return (
    <iframe
      src={episode?.spotify_url}
      width={width}
      height={152}
      title="spotify-iframe"
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture;"
      sandbox="allow-scripts allow-same-origin"
      loading="lazy"
      seamless
      style={{ border: 0, borderRadius: 12 }}
    />
  );
};
